import { render } from "./B2bTableLinesDeliveryNotesReceived.vue?vue&type=template&id=21707ddd&scoped=true&lang=pug"
import script from "./B2bTableLinesDeliveryNotesReceived.vue?vue&type=script&lang=js"
export * from "./B2bTableLinesDeliveryNotesReceived.vue?vue&type=script&lang=js"

import "./B2bTableLinesDeliveryNotesReceived.vue?vue&type=style&index=0&id=21707ddd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21707ddd"]])

export default __exports__